module.exports = __webpack_public_path__ + "img/About_Desktop_04.0adaed7f.jpg";